export default {
    bioLogo:    '/assets/img/tin/bio-logo.svg',
    sticker:    '/assets/img/tin/Sticker.png',
    logo:       {
        text:       'mymuesli',
        fontSize:   342,
    },
    icons:      {
        size:       60,
        max:        14, // maximal number of icons displayed in sticker
        loveIcon:   {
            name:   '', // @todo: async translation with promises
            image:  '/assets/img/icons/liebe.svg',
        }
    }
}